import { Outlet, useLocation } from 'react-router-dom';
import { cn } from '@ridemaadi/utils';
import { AppHeader } from './AppHeader';
import { SmartHeaderProvider } from './header/SmartHeaderProvider';
import { BottomNavigation } from './BottomNavigation';
import { OfflineBanner } from '../../pwa/OfflineBanner';
import { InstallBanner } from '../../pwa/InstallBanner';
import { UpdateToast } from '../../pwa/UpdateToast';
import { RideStartNotificationListener } from '../../features/rides/RideStartNotificationListener';
import { RideStartedBanner, useRideStartedBanner } from '../../features/rides/RideStartedBanner';
import {
  RideCompletionCelebrationProvider,
  RideCompletionNotificationListener,
} from '../../features/rides/completion';
import { RideModeProvider } from '../../features/rides/rideMode/RideModeProvider';

/** Native-style shell: smart header, scrollable center, fixed bottom nav. */
export function AppShell() {
  const { pathname } = useLocation();
  const isCreateRide = pathname === '/rides/new';
  const { payload, show, dismiss, open } = useRideStartedBanner();

  return (
    <SmartHeaderProvider scrollRootId="app-scroll-region">
      <RideModeProvider>
        <RideCompletionCelebrationProvider>
        <div className="flex h-dvh flex-col overflow-hidden bg-bg">
        <AppHeader />
        {payload && <RideStartedBanner payload={payload} onDismiss={dismiss} onOpen={open} />}
        <RideStartNotificationListener onRideStarted={show} />
        <RideCompletionNotificationListener />
        <OfflineBanner />
        <main
          className={cn(
            'mx-auto w-full min-h-0 min-w-0 max-w-app flex-1 overflow-x-hidden overflow-y-auto overscroll-y-contain scroll-smooth pb-8',
            isCreateRide ? 'px-0 pt-0' : 'px-4 pt-4',
          )}
          style={{ WebkitOverflowScrolling: 'touch' }}
          id="app-scroll-region"
        >
          <Outlet />
        </main>
        <BottomNavigation />
        <InstallBanner />
        <UpdateToast />
        </div>
        </RideCompletionCelebrationProvider>
      </RideModeProvider>
    </SmartHeaderProvider>
  );
}
